<template>
  <div class="ImportForm">
    <Steps :hasListedSteps="true">
      <template #0>
        <section :title="$t('projectDetails')">
          <Row>
            <Column :lg="6">
              <DatePicker
                :label="$t('date')"
                required
                :value.sync="importData.date" />
            </Column>
            <Column :lg="6">
              <Row>
                <Column :xs="8">
                  <Field
                    :label="$t('projectId')"
                    required
                    :value.sync="importData.orderNo"
                    @focusout="getContactByOrderNo" />
                </Column>
                <Column :xs="4">
                  <Btn
                    class="fetchScoro"
                    :disabled="!importData.orderNo"
                    :isLoading="isFetchingClient"
                    @click="getContactByOrderNo">
                    {{ $t('fetchScoro') }}
                  </Btn>
                </Column>
              </Row>
            </Column>
          </Row>
          <Row>
            <Column :lg="6">
              <Field
                :label="$t('managerId')"
                :options="managerOptions"
                required
                type="select"
                :value.sync="importData.managerId" />
            </Column>
            <Column :lg="6">
              <Field
                disabled
                :label="$t('clientId')"
                required
                :value.sync="importData.clientId" />
            </Column>
          </Row>
          <Field
            disabled
            :label="$t('clientName')"
            required
            :value.sync="importData.clientName" />
          <div class="addressContainer">
            <Field
              disabled
              :label="$t('address')"
              required
              type="textarea"
              :value="address" />
          </div>
        </section>
      </template>
      <template #1>
        <section :title="$t('scoroProducts')">
          <ScoroProducts :products="productsScoro" />
        </section>
      </template>
      <template #1-next>
        <Btn type="submit">
          {{ $t('continue') }}
        </Btn>
      </template>
      <template #2>
        <section :title="$t('itemsList')">
          <Field
            class="fullHeight"
            :label="$t('inputExcel')"
            type="textarea"
            :value.sync="importData.input" />
        </section>
      </template>
      <template #2-next>
        <Btn type="submit" @click.native="parse($event)">
          {{ $t('continue') }}
        </Btn>
      </template>
      <template #3>
        <section class="filledHeight" :title="$t('sendToDirecto')">
          <h4 id="preview" class="label">
            {{ $t('preview') }}
          </h4>
          <Tabs>
            <Sect slot="JSON">
              <Field
                class="fullHeight"
                disabled
                type="textarea"
                :value.sync="importData.preview" />
            </Sect>
            <Sect slot="XML">
              <Field
                class="fullHeight"
                disabled
                type="textarea"
                :value.sync="jsonToXML" />
            </Sect>
          </Tabs>
          <Field
            :label="$t('checkToVerify')"
            type="checkbox"
            :value.sync="isVerified" />
        </section>
      </template>
      <template #3-next>
        <Btn
          class="sendToDirecto"
          :disabled="!isVerified"
          :isLoading="isSendingToDirecto"
          type="submit"
          @click="sendToDirecto">
          {{ $t('sendToDirecto') }}
        </Btn>
      </template>
    </Steps>
  </div>
</template>

<script>
import { actions, getters } from '../../utils'
import DatePicker from 'components/DatePicker'
import ScoroProducts from 'components/ScoroProducts'
import Steps from 'components/Steps'
import Tabs from 'components/Tabs'
import builder from 'xmlbuilder'
import { scrollToHash } from '../../../router/smoothScroll'

export default {
  components: {
    DatePicker,
    Tabs,
    ScoroProducts,
    Steps,
  },
  // props: {
  //   importData: Object,
  // },
  data() {
    return {
      importData: {
        input: null,
        date: new Date(),
        orderNo: null,
        managerId: null,
        clientId: null,
        clientName: null,
        address1: null,
        address2: null,
        address3: null,
        isVerified: null,
        preview: null,
        lines: null,
      },
      isVerified: false,
      isFetchingClient: false,
      isSendingToDirecto: false,
      productsScoro: [],
      managerOptions: [
        'AGNIUS',
        'ANDRZEJ',
        'DARIA',
        'DZIUGAS',
        'EIMANTAS',
        'EVELINA',
        'GEDIMINAS',
        'GERDA',
        'JOLANTA',
        'JULIJA',
        'LEINONEN',
        'LIUTAURAS',
        'MANTAS',
        'MARIJA',
        'MYKOLAS',
      ],
    }
  },
  computed: {
    productsScoroFormated() {
      const productsWithoutCode = product => !!product.code
      const removeUnneededFields = product => ({
        label: product.label,
        code: product.code,
        quantity: product.quantity,
      })
      const addLinesNumbers = (product, index) => ({
        ...product,
        rn: index + 1,
        rv: index + 1,
      })

      return this.productsScoro
        .filter(productsWithoutCode)
        .map(removeUnneededFields)
        .map(addLinesNumbers)
    },
    address() {
      const { address1, address2, address3 } = this.importData
      return [address1, address2, address3]
        .filter(Boolean)
        .join(', ')
    },
    jsonToXML() {
      const {
        address1,
        address2,
        address3,
        date,
        preview,
        clientName,
        clientId,
        managerId,
        orderNo,
      } = this.importData

      const customOrderNo = orderNo
        ? `${orderNo}_${this.$d(new Date(), 'shortest').replace(/-/g, '')}`
        : null

      const xml = builder.create('orders')
        .ele('order', {
          appkey: process.env.DIRECTO_API_KEY,
          date: date?.toISOString().slice(0, 10),
          cust_order_no: customOrderNo,
          customer: clientId,
          customer_name: clientName,
          del_address1: address1,
          del_address2: address2,
          del_address3: address3,
          stock: 'PAGRINDINIS',
          salesman: managerId,
        })

      if (!preview) return

      JSON.parse(preview).forEach((row, index) => {
        const { rn, rv, code, quantity } = row
        xml.ele('line', {
          rn,
          rv,
          pricewovat: 0,
          quantity,
          code,
        })
      })

      return xml.end({ pretty: true })
    },
    ...getters(),
  },
  methods: {
    parse(event) {
      const { input } = this.importData

      try {
        // if (!input) throw new Error(this.$t('inputCannotBeEmpty'))
        if (!input) {
          this.importData.preview = JSON.stringify(this.productsScoroFormated, null, '  ')
        } else {
          const result = input
            .trim('\n')
            .split('\n')
            .map(row => {
              const columns = row
                .replace(/(\t)\1+/g, '\t')
                .split('\t')

              const [
                rn,
                rv,
                code,
                label,
                quantity,
              ] = columns

              if (!code || label === 'Produkto pavadinimas, kodas' || columns.length < 5) return

              return {
                rn,
                rv,
                code,
                label,
                quantity: parseFloat(quantity),
              }
            })
            .filter(Boolean)
            .filter(row => row.code)

          if (result.length === 0) throw new Error(this.$t('badInputFormat'))

          const productsMerged = this.mergeProducts(this.productsScoroFormated, result)

          // this.importData.preview = JSON.stringify(result, null, '  ')
          this.importData.preview = JSON.stringify(productsMerged, null, '  ')
        }
      } catch (error) {
        event.preventDefault()
        this.ERROR(error)
      }
    },
    mergeProducts(productsExisting, productsNew) {
      if (!productsExisting || !productsExisting.length) return productsNew

      const lastExistingLine = productsExisting[productsExisting.length - 1].rn
      const productsNewAdjustedLines = this.adjustLineNumbers(productsNew, lastExistingLine)

      return [
        ...productsExisting,
        ...productsNewAdjustedLines,
      ]
    },
    adjustLineNumbers(products, numberLast) {
      return products.map(product => ({
        ...product,
        rn: Number(product.rn) + Number(numberLast),
        rv: Number(product.rv) + Number(numberLast),
      }))
    },
    clearClientData() {
      this.importData.clientName = null
      this.importData.clientId = null
      this.importData.address1 = null
      this.importData.address2 = null
      this.importData.address3 = null
      this.productsScoro = []
    },
    async getContactByOrderNo() {
      const { orderNo } = this.importData

      this.clearClientData()

      try {
        if (!orderNo) {
          throw new Error('Project ID cannot not be empty')
        }

        this.isFetchingClient = true
        const [order] = await this.FIND_SCORO_ORDER({ no: orderNo })

        const contactId = order.company_id
        const orderId = order.id

        this.productsScoro = await this.GET_SCORO_MAIN_PRODUCTS(orderId)

        if (!contactId) {
          throw new Error('Project has empty company_id')
        }

        const contact = await this.GET_SCORO_CONTACT(contactId)

        if (contact) {
          this.importData.clientName = contact.search_name
          this.importData.clientId = contact.contact_id

          if (!contact.addresses || contact.addresses.length < 1) throw new Error('Adresas nerastas!')

          const [address] = contact.addresses

          if (address) {
            this.importData.address1 = address.street || '-'
            this.importData.address2 = address.city || '-'
            this.importData.address3 = address.zipcode || '-'
          }
        }

        scrollToHash('#preview')
      } catch (error) {
        if (!error.ignore) {
          this.ERROR(error)
        }
      } finally {
        this.isFetchingClient = false
      }
    },
    async sendToDirecto() {
      this.isSendingToDirecto = true

      try {
        await this.CREATE_DIRECTO({ action: 'new', xmlData: this.jsonToXML })
        this.SUCCESS('Sėkmingas siuntimas')
      } catch (error) {
        if (!error.ignore) {
          this.ERROR(error)
        }
      } finally {
        this.isSendingToDirecto = false
      }
    },
    managerAutoSelect() {
      if (this.importData.managerId) return

      const nameFromList = this.managerOptions.find(manager => manager === this.authUser.firstName.toUpperCase())
      if (!nameFromList) return

      this.importData.managerId = nameFromList
    },
    ...actions(
      'CREATE_DIRECTO',
      'FIND_SCORO_ORDER',
      'GET_SCORO_CONTACT',
      'GET_SCORO_MAIN_PRODUCTS',
    ),
  },
  created() {
    this.managerAutoSelect()
  },
}
</script>

<style lang="scss">
.ImportForm {
  height: 100%;

  .sendToDirecto {
    text-transform: uppercase;
  }

  .Btn.fetchScoro {
    margin-top: 2.5rem;
  }

  .Steps {
    display: flex;
    flex-direction: column;
    height: 100%;

    > form {
      height: 100%;

      > span {
        display: flex;
        flex-direction: column;
        height: 100%;

        > .current {
          height: 100%;
        }

        section {
          height: 100%;

          .addressContainer {
            height: 10rem;

            .Field {
              height: 100%;

              textarea {
                max-height: 100%;
                min-height: unset;
              }
            }
          }

          .fullHeight {
            display: flex;
            flex-direction: column;
            height: 100%;

            > .Field {
              height: 100%;

              textarea {
                height: 100%;
              }
            }
          }
        }
      }
    }
  }

  h4.label {
    line-height: 2.5rem;
  }

  .filledHeight {
    display: flex;
    flex-direction: column;

    .Tabs {
      display: flex;
      flex-direction: column;
      height: 100%;

      .body {
        height: 100%;

        .Sect {
          height: 100%;
        }
      }
    }

    > .fullHeight {
      display: flex;
      flex-direction: column;
      height: 100%;

      .Field {
        height: 100%;

        textarea {
          height: 100%;
          white-space: pre;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "inputExcel": "Lentelė iš Excel",
    "scoroProducts": "Prekės iš Scoro",
    "itemsList": "Kitos prekės",
    "projectDetails": "Projektas",
    "sendToDirecto": "Siųsti į Directo",
    "preview": "Peržiūra",
    "date": "Data",
    "projectId": "Projekto ID (Scoro Order ID)",
    "managerId": "Vadybininkas",
    "address": "Adresas",
    "clientId": "Kliento ID",
    "clientName": "Klientas",
    "fetchScoro": "Gauti iš Scoro",
    "checkToVerify": "Patvirtinti",
    "parse": "Parse",
    "badInputFormat": "Netinkamas formatas",
    "continue": "Tęsti",
    "inputCannotBeEmpty": "Laukas negali būti tuščias"
  }
}
</i18n>
